var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgForward(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.627 12.75H5.25a.726.726 0 01-.535-.215A.726.726 0 014.5 12c0-.213.072-.391.215-.534a.726.726 0 01.535-.216h11.377l-5.17-5.17a.705.705 0 01-.22-.521c.002-.2.08-.377.236-.532A.783.783 0 0112 4.802a.7.7 0 01.527.225l6.34 6.34a.829.829 0 01.256.633.829.829 0 01-.256.633l-6.34 6.34a.715.715 0 01-.514.213.748.748 0 01-.54-.213.735.735 0 01-.233-.534c0-.202.078-.38.233-.535l5.154-5.154z",
    fill: "currentColor"
  })));
}
SvgForward.displayName = 'Forward';
export default SvgForward;